<template>
  <div class="app-download-qr-code-container relative mb-2">
    <div class="app-download-qr-animated-border absolute" />
    <img v-if="loaded" :src="imageSource" alt="App Download QR-Code" :class="classNames" />
  </div>
</template>

<script>
import { mapState } from "vuex"
import api from "@/api"

export default {
  name: "AppDownloadQrCode",
  props: {
    buttonCode: { type: String, default: "body-20200319-store_badge" }
  },
  data() {
    return {
      encodedImage: null
    }
  },
  computed: {
    ...mapState({
      fingerprint: (state) => state.user.fingerprint
    }),
    classNames() {
      return [
        "app-download-qr-code-qr",
        "flex-grow",
        "absolute",
        `store-cta--${this.platform}`,
        `store-cta--${this.$i18n.locale}`,
        "js-adjust-link"
      ]
    },
    imageSource() {
      return `data:image/png;base64,${this.encodedImage}`
    },
    downloadAppUrl() {
      return this.$store.getters.downloadAppUrl({ buttonCode: this.buttonCode })
    },
    loaded() {
      return this.fingerprint && this.encodedImage
    }
  },
  mounted() {
    this.fetchQrImageIfPossible()
  },
  updated() {
    this.fetchQrImageIfPossible()
  },
  methods: {
    fetchQrImageIfPossible() {
      // The fingerprint is used to build the app download url, so we cannot
      // request the QR code until the fingerprint is ready.
      if (this.fingerprint) {
        this.fetchQrImage()
      }
    },
    fetchQrImage() {
      api.appInstallQrCode.fetch(this.downloadAppUrl).then((response) => {
        this.encodedImage = response.image
      })
    }
  }
}
</script>

<style lang="scss">
$qr-border-width: 20px;

$qr-border-thickness: 4px;
$qr-border-gradient-config: transparent 90deg, $green 0;

.app-download-qr-code-container {
  width: 230px;
  height: 230px;
}

.app-download-qr-code-qr {
  image-rendering: pixelated; /* Fixes blurry issue for Chrome non-retina screen */

  top: 0;
  left: 0;

  width: 230px;
  height: 230px;
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes fadeoutin {
  0%,
  100% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

.app-download-qr-animated-border {
  top: rem(13px);

  left: rem(13px);

  z-index: 10; // place it over the qr code

  width: 201px;
  height: 201px;

  background: conic-gradient(
        from 90deg at top $qr-border-thickness left $qr-border-thickness,
        $qr-border-gradient-config
      )
      0 0,
    conic-gradient(from 180deg at top $qr-border-thickness right $qr-border-thickness, $qr-border-gradient-config) 100%
      0,
    conic-gradient(from 0deg at bottom $qr-border-thickness left $qr-border-thickness, $qr-border-gradient-config) 0
      100%,
    conic-gradient(from -90deg at bottom $qr-border-thickness right $qr-border-thickness, $qr-border-gradient-config)
      100% 100%;
  background-repeat: no-repeat;
  background-size: $qr-border-width $qr-border-width;
  background-origin: border-box;
  border: $qr-border-thickness solid transparent; /* space for the border */

  animation-name: fadeoutin, fadeoutin, fadeout;
  animation-duration: 550ms, 550ms, 250ms;
  animation-timing-function: linear, linear, linear;
  animation-delay: 5000ms, 6000ms, 6900ms;
  animation-iteration-count: 1, 1, 1;
  animation-fill-mode: none, none, forwards;
}
</style>
